


import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

export default function AgbPage({ showBackButton = false, onBack = null }) {
  const navigate = useNavigate();
const location = useLocation();
const { t } = useLanguage();

const handleBack = () => {
  if (typeof onBack === "function") {
    onBack();
    return;
  }
  if (location.state?.from === "landing") {
    navigate("/landing");
    return;
  }
  if (
    typeof window !== "undefined" &&
    window.sessionStorage?.getItem("vaultquest:returnToRegister") === "1"
  ) {
    navigate("/login");
    return;
  }
  navigate("/");
};

 return (
  <div
    style={{
      width: "92%",
      margin: "0 auto",
      padding: "calc(18px + var(--vq-safe-area-top)) calc(16px + var(--vq-safe-area-right)) calc(28px + var(--vq-safe-area-bottom)) calc(16px + var(--vq-safe-area-left))",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.04)",
      border: "1px solid rgba(255,255,255,0.10)",
      color: "white",
      boxSizing: "border-box",
    }}
  >
  {showBackButton && (
  <button
    onClick={handleBack}
    style={{
      background: "transparent",
      border: "1px solid rgba(255,255,255,0.2)",
      color: "#fff",
      padding: "10px 16px",
      borderRadius: "10px",
      cursor: "pointer",
      marginBottom: "30px",
      fontSize: "15px",
    }}
  >
    ← {t("common.back")}
  </button>
)}

    <h1 style={{ marginTop: 0, fontSize: "clamp(22px, 5vw, 28px)", fontWeight: "800", marginBottom: "24px", lineHeight: 1.2 }}>
  {t("agb.title")}
</h1>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section1Title")}
</h2>

   <p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section1Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section1Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section1List1")}</li>
  <li>{t("agb.section1List2")}</li>
  <li>{t("agb.section1List3")}</li>
  <li>{t("agb.section1List4")}</li>
  <li>{t("agb.section1List5")}</li>
  <li>{t("agb.section1List6")}</li>
  <li>{t("agb.section1List7")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section1Text3")}
</p>

    <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section2Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.providerName")}<br />
  {t("agb.providerStreet")}<br />
  {t("agb.providerCity")}<br />
  {t("agb.providerCountry")}<br />
  {t("agb.providerEmailLabel")}: {t("agb.providerEmail")}
</p>

  <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section3Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section3Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section3Text2")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section3Text3")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section3Text4")}
</p>

    <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section4Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section4Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section4Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section4List1")}</li>
  <li>{t("agb.section4List2")}</li>
  <li>{t("agb.section4List3")}</li>
  <li>{t("agb.section4List4")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section4Text3")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section4Text4")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section4Text5")}
</p>

    <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section5Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section5Text1")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section5List1")}</li>
  <li>{t("agb.section5List2")}</li>
  <li>{t("agb.section5List3")}</li>
  <li>{t("agb.section5List4")}</li>
  <li>{t("agb.section5List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section5Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section5List6")}</li>
  <li>{t("agb.section5List7")}</li>
  <li>{t("agb.section5List8")}</li>
  <li>{t("agb.section5List9")}</li>
  <li>{t("agb.section5List10")}</li>
  <li>{t("agb.section5List11")}</li>
  <li>{t("agb.section5List12")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section5Text3")}
</p>

    <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section6Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section6Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section6Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section6List1")}</li>
  <li>{t("agb.section6List2")}</li>
  <li>{t("agb.section6List3")}</li>
  <li>{t("agb.section6List4")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section6Text3")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section6Text4")}
</p>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section7Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section7Text1")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section7List1")}</li>
  <li>{t("agb.section7List2")}</li>
  <li>{t("agb.section7List3")}</li>
  <li>{t("agb.section7List4")}</li>
  <li>{t("agb.section7List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section7Text2")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section7Text3")}
</p>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section8Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section8List1")}</li>
  <li>{t("agb.section8List2")}</li>
  <li>{t("agb.section8List3")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text3")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section8List4")}</li>
  <li>{t("agb.section8List5")}</li>
  <li>{t("agb.section8List6")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text4")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text5")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section8List7")}</li>
  <li>{t("agb.section8List8")}</li>
  <li>{t("agb.section8List9")}</li>
  <li>{t("agb.section8List10")}</li>
  <li>{t("agb.section8List11")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text6")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section8Text7")}
</p>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section9Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section9Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section9Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section9List1")}</li>
  <li>{t("agb.section9List2")}</li>
  <li>{t("agb.section9List3")}</li>
  <li>{t("agb.section9List4")}</li>
  <li>{t("agb.section9List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section9Text3")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section9List6")}</li>
  <li>{t("agb.section9List7")}</li>
  <li>{t("agb.section9List8")}</li>
  <li>{t("agb.section9List9")}</li>
  <li>{t("agb.section9List10")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section9Text4")}
</p>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section10Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section10Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section10Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section10List1")}</li>
  <li>{t("agb.section10List2")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section10Text3")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section10List3")}</li>
  <li>{t("agb.section10List4")}</li>
  <li>{t("agb.section10List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section10Text4")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section10Text5")}
</p> 

  <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section11Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section11Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section11Text2")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section11List1")}</li>
  <li>{t("agb.section11List2")}</li>
  <li>{t("agb.section11List3")}</li>
  <li>{t("agb.section11List4")}</li>
  <li>{t("agb.section11List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section11Text3")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section11Text4")}
</p>  

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section12Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section12Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section12Text2")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section12Text3")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section12List1")}</li>
  <li>{t("agb.section12List2")}</li>
  <li>{t("agb.section12List3")}</li>
  <li>{t("agb.section12List4")}</li>
  <li>{t("agb.section12List5")}</li>
</ul>

   <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section13Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section13Text1")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section13List1")}</li>
  <li>{t("agb.section13List2")}</li>
  <li>{t("agb.section13List3")}</li>
  <li>{t("agb.section13List4")}</li>
  <li>{t("agb.section13List5")}</li>
</ul>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section13Text2")}
</p>

<h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section14Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section14Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section14Text2")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section14Text3")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section14Text4")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section14Text5")}
</p>

<ul style={{ marginTop: "10px", lineHeight: "1.6", paddingLeft: "20px" }}>
  <li>{t("agb.section14List1")}</li>
  <li>{t("agb.section14List2")}</li>
  <li>{t("agb.section14List3")}</li>
</ul>

<h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section15Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section15Text1")}
</p>

<h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section16Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section16Text1")}
</p>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section16Text2")}
</p>

<h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("agb.section17Title")}
</h2>

<p style={{ marginTop: "15px", lineHeight: "1.6" }}>
  {t("agb.section17Text1")}
</p>
  </div>
);
}
